import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { AppState } from "../types";
import { addFleetManagerHubReconnectHandler } from "./fleetManagerHubReconnectHandlers";

const REFRESH_DELAY_MS = 300;

export const useDisconnectedDrivingUpdates = (refresh: () => void) => {
  const { hub } = useSelector((state: AppState) => state.fleetManagerHub);
  const refreshRef = useRef(refresh);
  refreshRef.current = refresh;

  useEffect(() => {
    if (!hub) {
      return;
    }

    let active = true;
    let refreshTimer: ReturnType<typeof setTimeout> | undefined;
    const scheduleRefresh = () => {
      if (refreshTimer) {
        clearTimeout(refreshTimer);
      }
      refreshTimer = setTimeout(() => {
        refreshTimer = undefined;
        if (active) {
          refreshRef.current();
        }
      }, REFRESH_DELAY_MS);
    };
    const handleReconnected = () => {
      if (active) {
        refreshRef.current();
      }
    };

    hub.on("OnDisconnectedDrivingRecorded", scheduleRefresh);
    const removeReconnectHandler = addFleetManagerHubReconnectHandler(
      hub,
      handleReconnected
    );
    return () => {
      active = false;
      if (refreshTimer) {
        clearTimeout(refreshTimer);
      }
      hub.off("OnDisconnectedDrivingRecorded", scheduleRefresh);
      removeReconnectHandler();
    };
  }, [hub]);
};
